import { Globe2 } from 'lucide-preact'
import { memo } from 'preact/compat'
import { DashboardStatTile } from './DashboardStatTile'

interface ActiveWebsStatTileProps {
  count: number | null | undefined
  rangeLabel?: string
  /**
   * What the count actually covers, which differs by scope: the workspace dashboard counts the webs
   * of every active campaign, the campaign tab counts that campaign's webs whatever its own status.
   * One static string could only ever be true for one of them, and the previous "Active webs
   * currently live" was true for neither — nothing here checks that a web is live (ORB-821).
   */
  badgeTitle: string
  loading?: boolean
  error?: string | null
  failed?: boolean
}

export const ActiveWebsStatTile = memo((props: ActiveWebsStatTileProps) => (
  <DashboardStatTile
    titleLines={['Active', 'Webs']}
    icon={<Globe2 className="w-5 h-5 text-primary-600 dark:text-primary-400" />}
    badge="Active"
    {...props}
  />
))
